<template>
  <path pid="0" d="M21 9a8 8 0 10-12.86 6.35L7 23.87A1 1 0 008 25a1.06 1.06 0 00.54-.14L13 22.17l4.49 2.69A1.06 1.06 0 0018 25a1 1 0 001-1.13l-1.13-8.52A8 8 0 0021 9zm-7.49 11.14a1 1 0 00-1 0l-3.25 1.93.74-5.65a7.76 7.76 0 003 .58 7.85 7.85 0 003-.58l.75 5.66zM16.33 14l-.14.09a6 6 0 11.14-.09z"/>
</template>
